import React from 'react';
import { Link } from 'react-router-dom';
import { PRACTICE_INFO, OFFICE_HOURS } from '../../data/navigation';
import s from './SidebarInfo.module.css';

export default function SidebarInfo() {
  return (
    <>
      {/* ── Contact Us card ─────────────────────────────── */}
      <div className={s.card}>
        <h4 className={s.cardTitle}>Contact Us</h4>
        <div className={s.divider} />

        <div className={s.row}>
          <svg className={s.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.63A2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.91a16 16 0 006.18 6.18l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
          </svg>
          <div>
            <span className={s.label}>Phone</span>
            <a href={`tel:${PRACTICE_INFO.phoneRaw}`} className={s.value}>{PRACTICE_INFO.phone}</a>
          </div>
        </div>

        <div className={s.row}>
          <svg className={s.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
          </svg>
          <div>
            <span className={s.label}>Email</span>
            <a href={`mailto:${PRACTICE_INFO.email}`} className={s.value}>{PRACTICE_INFO.email}</a>
          </div>
        </div>

        <div className={s.row}>
          <svg className={s.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
          </svg>
          <div>
            <span className={s.label}>Address</span>
            <a href={PRACTICE_INFO.mapUrl} target="_blank" rel="noreferrer" className={s.value}>
              {PRACTICE_INFO.address}<br />{PRACTICE_INFO.city}, {PRACTICE_INFO.state} {PRACTICE_INFO.zip}
            </a>
          </div>
        </div>

        <Link to="/contact" className={s.ctaBtn}>Contact Us</Link>
      </div>

      {/* ── Office Hours card ────────────────────────────── */}
      <div className={s.card}>
        <h4 className={s.cardTitle}>Office Hours</h4>
        <div className={s.divider} />

        <div className={s.hoursList}>
          {OFFICE_HOURS.map((row) => (
            <div key={row.day} className={s.hoursRow}>
              <span className={s.hoursDay}>{row.day}</span>
              <span className={row.closed ? s.hoursClosed : s.hoursTime}>{row.hours}</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
